import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import Footer from "./components/Footer/Footer";
import JobOpenings from "./components/Recruitment/Job Posting/JobOpenings";
import "./App.css";

function App() {
  return (
    <Router>
      <div className="app-layout">
        <main className="app-content-scroll">
          <Routes>
            <Route path="/" element={<JobOpenings />} />
            <Route path="/:jobId" element={<JobOpenings />} />
            <Route path="/recruitment/job-openings" element={<JobOpenings />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
